<template>
  <div>
    <div class="flex-spc-x">
      <div>
        <el-popover placement="right" width="270" trigger="hover" v-if="isShowLottery">
          <img
            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/wzsyt.png"
            alt=""
          />
          <div slot="reference" class="tip-color">位置示意图</div>
        </el-popover>
        <slot></slot>
        <div v-if="!isShowLottery"></div>
      </div>
      <p>
        累计中奖率：<span class="red-color">{{ Number(winningRate).toFixed(decimalNum) }} %</span>
      </p>
    </div>
    <jd-table
      :isIndex="isShowIndex"
      :tableData="newPrizeSettingList"
    >
      <el-table-column label="位置" width="100" v-if="isShowLottery">
        <template slot-scope="scope">
          <span v-if="scope.$index == 0">一</span>
          <span v-if="scope.$index == 1">二</span>
          <span v-if="scope.$index == 2">三</span>
          <span v-if="scope.$index == 3">四</span>
          <span v-if="scope.$index == 4">五</span>
          <span v-if="scope.$index == 5">六</span>
          <span v-if="scope.$index == 6">七</span>
          <span v-if="scope.$index == 7">八</span>
          <span v-if="scope.$index == 8">九</span>
        </template>
      </el-table-column>

      <el-table-column label="选择奖品" minWidth="80">
        <template slot-scope="scope">
          <jd-button
            type="blueText"
            :disabled="isDisabled&&!scope.row.isAdd"
            @click="centerVis(scope.row, scope.$index, 0)"
            >选奖品</jd-button
          >
        </template>
      </el-table-column>

      <el-table-column label="奖品类型" minWidth="120">
        <template slot-scope="scope">
          {{ getPrizeTypeName(scope.row.prizeType) }}
        </template>
      </el-table-column>

      <el-table-column label="值" minWidth="80" prop="price"> </el-table-column>

      <el-table-column label="奖品名称（12字内）" minWidth="250">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.title"
            maxlength="12"
            :disabled="scope.row.prizeType == 9"
            show-word-limit
            :style="{ width: isShowLottery ? '220px' : '240px' }"
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="奖品总数" minWidth="120">
        <template slot-scope="scope">
          <el-input
            v-model.number="scope.row.totalAmount"
            @input.native="
              (e) => (scope.row.totalAmount = checkputn(e, scope.row, 'jindou'))
            "
            placeholder="请输入"
            style="width: 80px"
            @input="
              (scope.row.totalAmount = isLimitPrizeCount ? getNumberData(1, $event, 0, 1,999999) : getNumberData(1, $event, 0, 1)),
                prizeNum(scope.row)
            "
            @blur="beAdd(scope.row)"
            :disabled="(isDisabled&&!scope.row.isAdd && !scope.row.minNum) || (isDisabled&&!scope.row.isAdd)"
          ></el-input>
          份
        </template>
      </el-table-column>

      <el-table-column
        label="每日发放限额"
        minWidth="120"
        align="center"
        v-if="isShowLottery || isShowLimit"
      >
        <template slot-scope="scope">
          <div style="text-align: center" @click="setLimit(scope.row)">
            <jd-button
              :disabled="dailyLimitDisabled ? false : (isDisabled && limitBtnDisabled) || !scope.row.totalAmount"
              v-if="!scope.row.dailyLimitType && !scope.row.dailyLimit"
              type="blueText"
            >
              配置
            </jd-button>
            <jd-button
              :disabled="dailyLimitDisabled ? false : isDisabled && limitBtnDisabled"
              v-if="scope.row.dailyLimitType == 0 && scope.row.dailyLimit"
              type="blueText"
            >
              每日发放{{ scope.row.dailyLimit }}份
            </jd-button>
            <div v-if="scope.row.dailyLimitType == 1">
              <div>
                <jd-button :disabled="dailyLimitDisabled ? false : isDisabled && limitBtnDisabled" type="blueText"
                  >闲时发放{{ scope.row.idleLimit }}份</jd-button
                >
              </div>
              <div>
                <jd-button :disabled="dailyLimitDisabled ? false : isDisabled && limitBtnDisabled" type="blueText"
                  >忙时发放{{ scope.row.busyLimit }}份</jd-button
                >
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <!--  @input="scope.row.percentage = handleInputPrice($event)" -->
      <el-table-column label="中奖率" minWidth="130">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.percentage"
            placeholder="请输入"
            style="width: 90px"
            @keyup.native="
              scope.row.percentage = oninput2(
                scope.row.percentage,
                scope.$index
              )
            "
            @blur="scope.row.percentage = getInputPercentage($event)"
            :disabled="
              !activityData.status
                ? false
                : !scope.row.totalAmount
                ? true
                : false
            "
          ></el-input>
          %
        </template>
      </el-table-column>
      <el-table-column label="最多中奖次数" minWidth="130" v-if="isShowLottery || isShowSingleMax">
        <template #header>
          <el-tooltip
            effect="light"
            content="当单个用户中奖次数达到设定上限后，后续抽奖不再分配该奖品，系统自动重配其他奖品。"
            placement="right"
          >
            <div>
              最多中奖次数<i style="color: #ccc" class="el-icon-question"></i>
            </div>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.singleMaxWin"
            placeholder="请输入"
            style="width: 80px"
            @input="
              scope.row.singleMaxWin = getNumberData(1, $event, 1, 0, 9999)
            "
            :disabled="
              !activityData.status || activityData.isCopy
                ? false
                : !scope.row.totalAmount
                ? true
                : false
            "
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="图片" minWidth="120">
        <template slot-scope="scope">
          <div class="logo-container">
            <img
              v-if="scope.row.logo"
              :src="scope.row.logo"
              class="logo-style"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="入会且已购中奖率"
        minWidth="150"
        v-if="isShowLottery&&isShowMemberBuyPercentage"
      >
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.memberBuyPercentage"
            @input="
              scope.row.memberBuyPercentage = getNumberData(
                1,
                $event,
                1,
                0,
                100
              )
            "
            placeholder="请输入"
            style="width: 80px"
            @keyup.native="
              scope.row.memberBuyPercentage = oninput2(
                scope.row.memberBuyPercentage,
                scope.$index,
                2
              )
            "
            :disabled="
              !activityData.status
                ? false
                : !scope.row.totalAmount
                ? true
                : false
            "
          ></el-input>
          %
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :minWidth="
          (isShowLottery && !isDisabled) || !isDisabled ? '160' : '220'
        "
        fixed="right"
      >
        <template slot-scope="scope">
          <jd-button
            type="blueText"
            :disabled="isDisabled&&!scope.row.isAdd"
            @click="cleanData(scope.row, scope.$index)"
            >清除</jd-button
          >
          <jd-button
            type="blueText"
            :disabled="isDisabled&&!scope.row.isAdd"
            @click="upPrizeSetting(scope.$index)"
            v-if="isShowMoveBtn && scope.$index != 0"
            >上移</jd-button
          >
          <jd-button
            type="blueText"
            :disabled="isDisabled&&!scope.row.isAdd"
            @click="downPrizeSetting(scope.$index)"
            v-if="
              isShowMoveBtn && scope.$index != newPrizeSettingList.length - 1
            "
            >下移</jd-button
          >
          <jd-button type="blueText" v-if="isShowDeleteBtn&&minLimit<newPrizeSettingList.length" :disabled="isDisabled&&!scope.row.isAdd" @click="deletePrizeSetting(scope.$index)"
            >删除</jd-button
          >
          <!-- <jd-button v-else type="blueText">清除</jd-button> -->
          <jd-button
            type="blueText"
            style="margin-left: 5px"
            v-if="
              !scope.row.isAdd&&isDisabled && scope.row.title && scope.row.title != '谢谢参与'
            "
            @click="itemAddNum('newPrizeSettingList', scope.$index)"
            >增加奖品数量</jd-button
          >
        </template>
      </el-table-column>
    </jd-table>
    <jd-button
      class="mt12"
      type="blue"
      v-if="isShowAddBtn"
      @click="addPrizeSetting"
      :disabled="newPrizeSettingList.length >= maxLimit ||(isDisabled&&!isAddPrize)"
      >{{ addPrizeText }}（{{ newPrizeSettingList.length }}/{{
        maxLimit
      }}）</jd-button
    >
    <jd-tip class="mt12" v-if="isShowTip">
      <div v-if="!isCustomizeTip">
        说明<br />
        <p>1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”</p>
        <p>
          2、中奖率/入会且已购中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
        </p>
        <p>
          3、为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担；
        </p>
        <p>4、进行中的活动修改中奖概率有一定客诉风险，不建议频繁修改。</p>
      </div>
      <div v-else>
        <slot name="tipText"></slot>
      </div>
    </jd-tip>

    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProductRef"
      v-if="isShowPrize"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :actType="actType"
      :actEndTime="actEndTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 每日发放限额弹窗 -->
    <setLimitDialog
      :visible.sync="showLimitDialog"
      :init-data="limitData"
      :backgroundOpacity="backgroundOpacity"
      @confirm="handleLimitConfirm"
    />
  </div>
</template>

<script>
import selectProduct from "../../select_product_componentization.vue";
import addPrizeNum from "../add-prize-num.vue";
import setLimitDialog from "../_components/setLimitDialog.vue";
export default {
  name: "lotteryPrize",
  components: {
    selectProduct,
    addPrizeNum,
    setLimitDialog,
  },
  props: {
    prizeSettingList: {
      type: Array,
      default: () => [],
    },
    // 进行中状态
    isDisabled: {
      type: Boolean,
      default: false,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    activityData: {
      type: Object,
      default: () => {},
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    // 是否显示奖项索引
    isShowIndex: {
      type: Boolean,
      default: false,
    },
    // 是否显示抽奖条件
    isShowLottery: {
      type: Boolean,
      default: true,
    },
    // 添加按钮文案
    addPrizeText: {
      type: String,
      default: "+添加奖项",
    },
    // 是否显示添加按钮
    isShowAddBtn: {
      type: Boolean,
      default: false,
    },
    // 最大奖品数
    maxLimit: {
      type: Number,
      default: 20,
    },
    minLimit: {
      type: Number,
      default: 5,
    },
    // 是否显示上移下移按钮
    isShowMoveBtn: {
      type: Boolean,
      default: false,
    },
    // 是否自定义提示
    isCustomizeTip: {
      type: Boolean,
      default: false,
    },
    // 是否显示删除按钮
    isShowDeleteBtn: {
      type: Boolean,
      default: false,
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    // 是否进行中新增奖品
    isAddPrize:{
      type: Boolean,
      default: false,
    },
    // 是否显示每日发放限额
    isShowLimit: {
      type: Boolean,
      default: false,
    },
    // 是否允许编辑每日发放限额
    limitBtnDisabled: {
      type: Boolean,
      default: true,
    },
    // 是否显示单人最多中奖次数
    isShowSingleMax: {
      type: Boolean,
      default: false,
    },
    actType: {
      type: Number,
      default: 0,
    },
    actEndTime: {
      type: String,
      default: '',
    },
    // 每日发放限额进行中是否允许编辑
    dailyLimitDisabled: {
      type: Boolean,
      default: false,
    },
    // 是否显示入会且已购中奖率
    isShowMemberBuyPercentage: {
      type: Boolean,
      default: true,
    },
    // 是否限制奖品总数
    isLimitPrizeCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      theNum: 0,
      limitData: {},
      showLimitDialog: false,
      prizeIndex: -1,
      winningRate: 0,
      toAddItem: {},
      toAddIndex: 0,
      isShowAddNum: false,
      JingdouCount: {
        prizeCount: 0,
      },
      isShowPrize: false,
      echoDate: {},
      itemArr: [],
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
    };
  },
  computed: {
    newPrizeSettingList: {
      get() {
        this.winningRate = this.prizeSettingList.reduce((pre, cur) => {
          return pre + Number(cur.percentage || 0);
        }, 0);
        return this.prizeSettingList;
      },
      set(val) {
        this.$emit("update:prizeSettingList", val);
      },
    },
    decimalNum() {
      return 5
    }
  },
  // watch: {
  //   theNum(newName, oldName) {
  //     this.winningRate = 0;
  //     this.newPrizeSettingList.forEach((item) => {
  //       if (item.percentage) {
  //         this.winningRate += Number(item.percentage);
  //       }
  //     });
  //     if(this.winningRate>=100) {
  //       this.winningRate = 100
  //     }
  //     this.winningRate = this.winningRate.toFixed(this.decimalNum);
  //   },
  // },
  methods: {
    upPrizeSetting(index) {
      this.newPrizeSettingList[index] = this.newPrizeSettingList.splice(
        index - 1,
        1,
        this.newPrizeSettingList[index]
      )[0];
    },
    downPrizeSetting(index) {
      this.newPrizeSettingList[index] = this.newPrizeSettingList.splice(
        index + 1,
        1,
        this.newPrizeSettingList[index]
      )[0];
    },
    deletePrizeSetting(index) {
      this.newPrizeSettingList.splice(index, 1);
    },
    addPrizeSetting() {
      if (this.newPrizeSettingList.length >= this.maxLimit) {
        this.$message.error("最多设置" + this.maxLimit + "个奖项");
        return;
      }
      this.$emit("addPrizeSetting");
    },
    centerVis(row, index) {
      this.prizeIndex = index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.isShowPrize = true;
      this.itemArr = this.prizeSettingList;
      this.$nextTick(() => {
        this.$refs.selectProductRef.openDialog();
      });
    },
    getPrizeCommon(data, prizeType) {
      console.log(data,'data');
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
        percentage: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price =
        prizeType == 13 && data.discount == "" ? "" : Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime ? data.isFollowActivityEndTime : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 12) {
        prizeObj.reducePrice = data.reducePrice;
      }
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj,prizeType,data);
      }
      return prizeObj;
    },
    getTheData(data, prizeType) {
      let prizeObj = this.getPrizeCommon(data, prizeType);
      this.$set(this.newPrizeSettingList, this.prizeIndex, {...prizeObj, isAdd: this.newPrizeSettingList[this.prizeIndex].isAdd});
    },
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.isDisabled) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    checkLimit(row, min) {
      let newVal = (row.dailyLimit + "").replace(/[^\d]/g, "");
      if (newVal) {
        if (newVal < min) {
          return "";
        } else {
          if (Number(row.dailyLimit) > Number(row.totalAmount)) {
            this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
            return "";
          } else {
            return Number(row.dailyLimit);
          }
        }
      }
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    // 保留小数点后两位
    oninput2(val, $index, type = 1) {
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }
      // 转换为数字进行计算
      const currentValue = parseFloat(val) || 0;
      // 计算当前所有奖项的中奖率总和（不包含当前正在编辑的项）
      let sumWithoutCurrent = 0;
      this.newPrizeSettingList.forEach((item, index) => {
        if (index !== $index && item.percentage) {
          sumWithoutCurrent += parseFloat(item.percentage);
        }
      });

      // 检查加上当前输入后是否超过100
      if (sumWithoutCurrent + currentValue > 100) {
        // 自动调整当前项的值，确保总和不超过100
        val = (100 - sumWithoutCurrent).toString();
      }

      let winningRate = 0;
      let totalMemberBuyPercentage = 0;
      this.newPrizeSettingList.forEach((item, index) => {
        if (item.percentage) {
          winningRate += parseFloat(item.percentage).toFixed(this.decimalNum) * 1;
        }
        if (type === 2) {
          totalMemberBuyPercentage += item.memberBuyPercentage * 1;
        }
        if ($index == index) {
          item.isWrite = true;
        }
      });
      // 入会且已购中奖率
      if (type === 2) {
        if (totalMemberBuyPercentage > 100) {
          val = String(100 - (totalMemberBuyPercentage - val));
        } else if (totalMemberBuyPercentage == 100) {
          if (val >= 100) {
            val = "100";
          } else {
            val = String(100 - (totalMemberBuyPercentage - val));
            if (val == 0) {
              val = "";
            }
          }
        }
      }

      val = val.substring(0, 10);

      this.theNum++;
      if(type==2) {
        return val ? val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3") : "";
      } else {
       return val ? val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d{1,5}).*$/, "$1$2.$3") : "";
      }
    },
    getInputPercentage(e) {
      let val = e.target.value;
      if(!this.isShowLottery&&val==0) {
        val = "";
        this.$message.warning("中奖概率不能为0%");
      }
      return val;
    },
    handleInputPrice(value) {
      // 过滤非数字和非小数点字符
      let filteredValue = value.replace(/[^0-9.]/g, "");

      // 确保只保留第一个小数点
      const firstDotIndex = filteredValue.indexOf(".");
      if (firstDotIndex !== -1) {
        const beforeDot = filteredValue.slice(0, firstDotIndex + 1);
        const afterDot = filteredValue
          .slice(firstDotIndex + 1)
          .replace(/\./g, "");
        filteredValue = beforeDot + afterDot;
      }

      // 处理整数部分前导零
      if (firstDotIndex === -1) {
        // 非小数，若数字不为 0，移除前导零
        if (filteredValue !== "0") {
          filteredValue = filteredValue.replace(/^0+/, "");
        }
      } else {
        const integerPart = filteredValue.slice(0, firstDotIndex);
        const decimalPart = filteredValue.slice(firstDotIndex);
        // 若整数部分非空且以多个 0 开头，只保留一个 0
        const cleanedIntegerPart = integerPart.replace(/^0+(?=\d)/, "");
        filteredValue = cleanedIntegerPart + decimalPart;
      }

      // 确保小数点不在开头
      filteredValue = filteredValue.replace(/^\./, "0.");

      // 确保只保留三位小数
      if (firstDotIndex !== -1) {
        const decimalPart = filteredValue.slice(firstDotIndex + 1);
        filteredValue =
          filteredValue.slice(0, firstDotIndex + 1) + decimalPart.slice(0, this.decimalNum);
      }

      return filteredValue;
    },
    // 每日发放限额弹窗确认
    handleLimitConfirm(data) {
      this.$set(this.limitData, "dailyLimitType", data.dailyLimitType);
      this.$set(this.limitData, "dailyLimit", data.dailyLimit);
      this.$set(this.limitData, "idleLimit", data.idleLimit);
      this.$set(this.limitData, "busyLimit", data.busyLimit);

      if (data.dailyLimitType == 0) {
        // 每日发放
        this.$delete(this.limitData, "idleLimit");
        this.$delete(this.limitData, "busyLimit");
      } else if (data.dailyLimitType == 1) {
        // 按闲忙时配置数量
        this.$delete(this.limitData, "dailyLimit");
      }
    },
    // 每日发放限额弹窗
    setLimit(row) {
      if (!row.totalAmount) {
        return this.$message.warning("请先输入奖品总数");
      }
      this.showLimitDialog = true;
      this.limitData = row;
    },
    cleanData(row) {
      row.assetsId = null;
      row.prizeType = this.isShowLottery ? 9 : null;
      row.price = null;
      row.title = this.isShowLottery ? "谢谢参与" : "";
      row.logo = null;
      row.percentage = "";
      row.totalAmount = null;
      row.shouldCollectExtraData = 0
      row.extraQuestion = null
      if (this.isShowLottery || this.isShowLimit) {
        row.memberBuyPercentage = "";
        row.singleAmount = null;
        row.dailyLimitType = 0;
        row.dailyLimit = null;
        row.busyLimit = null;
        row.idleLimit = null;
        row.singleMaxWin = "";
      }
      this.winningRate = 0;
      this.newPrizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(this.decimalNum);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.red-color {
  margin-left: 4px;
  color: #fe4d45;
}
.tip-color {
  width: fit-content;
  color: #333333;
}

.logo-container {
  height: 66px;
  display: flex;
  align-items: center;
  .logo-style {
    width: 56px;
    height: 56px;
    border-radius: 4px;
  }
}

</style>
